var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107 106",
    width: 107,
    height: 106,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-738-1789h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#ddf5ff}.b{fill:#c1e9f4}.c{fill:#495959}.d{fill:#6dc54a}.e{fill:#ffcd50}.f{fill:#5db33a}.g{fill:#ffbc27}.h{fill:#ff7c48}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m8.9 98l7.4 7.4c0.9 0.8 2.3 0.8 3.1 0l7.4-7.4 7.4 7.4c0.8 0.8 2.2 0.8 3.1 0l7.4-7.4 7.4 7.4c0.8 0.8 2.2 0.8 3 0l7.4-7.4 6.7 6.7c0.9 0.8 2.3 0.2 2.3-0.9v-101.4c0-1.2-1-2.2-2.2-2.2h-67.1c-1.2 0-2.2 1-2.2 2.2v101.4c0 1.1 1.4 1.7 2.2 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m66.6 0.2v95.2l-2.5-2.6c-0.9-0.9-2.3-0.9-3.1 0l-7.4 7.4-7.4-7.4c-0.8-0.9-2.2-0.9-3.1 0l-7.4 7.4-7.4-7.4c-0.8-0.9-2.2-0.9-3 0l-7.4 7.4-7.4-7.4c-0.9-0.9-2.3-0.9-3.1 0l-7.4 7.4v3.6c0 1.1 1.4 1.7 2.2 0.9l6.7-6.7 7.4 7.4c0.9 0.8 2.3 0.8 3.1 0l7.4-7.4 7.4 7.4c0.8 0.8 2.2 0.8 3.1 0l7.4-7.4 7.4 7.4c0.8 0.8 2.2 0.8 3 0l7.4-7.4 6.7 6.7c0.9 0.8 2.3 0.2 2.3-0.9v-101.4c0-1.2-1-2.2-2.2-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m24.9 12.6v1c0 1.2-0.4 2.3-1.1 3.1 0.7 0.8 1.1 1.9 1.1 3v1.1c0 2.6-2.1 4.7-4.7 4.7h-4.5c-1.5 0-2.7-1.2-2.7-2.7v-12.2c0-1.5 1.2-2.7 2.7-2.7h4.5c2.6 0 4.7 2.1 4.7 4.7zm-8.7-1.4v3.9h4c0.8 0 1.4-0.7 1.4-1.5v-1c0-0.8-0.6-1.4-1.4-1.4zm5.4 8.5c0-0.8-0.6-1.4-1.4-1.4h-4v3.9h4c0.8 0 1.4-0.6 1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m43.2 22.2h-7v-12.7c0-0.9-0.8-1.6-1.7-1.6-0.9 0-1.6 0.7-1.6 1.6v14.3c0 0.9 0.7 1.7 1.6 1.7h8.7c0.9 0 1.6-0.8 1.6-1.7 0-0.9-0.7-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m56.9 22.2h-7.1v-12.7c0-0.9-0.7-1.6-1.6-1.6-0.9 0-1.6 0.7-1.6 1.6v14.3c0 0.9 0.7 1.7 1.6 1.7h8.7c0.9 0 1.6-0.8 1.6-1.7 0-0.9-0.7-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m28.9 7.9c-0.9 0-1.6 0.7-1.6 1.6v14.3c0 0.9 0.7 1.7 1.6 1.7 0.9 0 1.6-0.8 1.6-1.7v-14.3c0-0.9-0.7-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m41.2 40.9h-27.4c-0.9 0-1.6-0.8-1.6-1.7 0-0.9 0.7-1.6 1.6-1.6h27.4c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.7-1.6 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m57.6 40.9h-9.9c-0.9 0-1.7-0.8-1.7-1.7 0-0.9 0.8-1.6 1.7-1.6h9.9c0.9 0 1.7 0.7 1.7 1.6 0 0.9-0.8 1.7-1.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m42.8 53.9h-29c-0.9 0-1.6-0.8-1.6-1.7 0-0.8 0.7-1.6 1.6-1.6h29c0.9 0 1.6 0.8 1.6 1.6 0 0.9-0.7 1.7-1.6 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m42.8 66.9h-29c-0.9 0-1.6-0.7-1.6-1.6 0-0.9 0.7-1.7 1.6-1.7h29c0.9 0 1.6 0.8 1.6 1.7 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m101.4 90.9h-54.5c-2.9 0-5.3-2.4-5.3-5.3v-32.8c0-3 2.4-5.3 5.3-5.3h54.5c2.9 0 5.3 2.3 5.3 5.3v32.8c0 2.9-2.4 5.3-5.3 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m55.5 73.3h-7.9c-0.9 0-1.6-0.7-1.6-1.6 0-0.9 0.7-1.6 1.6-1.6h7.9c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m52.9 82.4h-5.3c-0.9 0-1.6-0.7-1.6-1.6 0-0.9 0.7-1.6 1.6-1.6h5.3c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m62.8 82.4h-5.3c-0.9 0-1.6-0.7-1.6-1.6 0-0.9 0.7-1.6 1.6-1.6h5.3c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m72.7 82.4h-5.3c-0.9 0-1.6-0.7-1.6-1.6 0-0.9 0.7-1.6 1.6-1.6h5.3c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m69.4 73.3h-7.9c-0.9 0-1.7-0.7-1.7-1.6 0-0.9 0.8-1.6 1.7-1.6h7.9c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m83.3 73.3h-7.9c-0.9 0-1.7-0.7-1.7-1.6 0-0.9 0.8-1.6 1.7-1.6h7.9c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m97.2 73.3h-8c-0.9 0-1.6-0.7-1.6-1.6 0-0.9 0.7-1.6 1.6-1.6h8c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m102.8 47.7q0.2 0.6 0.2 1.4v35.9c0 1.2-1 2.2-2.2 2.2h-57.6q-0.7 0-1.4-0.2c0.6 2.2 2.7 3.9 5.1 3.9h54.5c2.9 0 5.3-2.4 5.3-5.3v-32.8c0-2.5-1.6-4.5-3.9-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m60.3 65.5h-10.6c-1.5 0-2.6-1.2-2.6-2.7v-7.3c0-1.4 1.1-2.6 2.6-2.6h10.6c1.4 0 2.6 1.2 2.6 2.6v7.3c0 1.5-1.2 2.7-2.6 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m60.3 52.9h-2.8c1.4 0 2.6 1.2 2.6 2.6v7.3c0 1.5-1.2 2.7-2.6 2.7h2.8c1.4 0 2.6-1.2 2.6-2.7v-7.3c0-1.4-1.2-2.6-2.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m100.9 81.1c0 2.2-1.8 3.9-4 3.9-2.2 0-4-1.7-4-3.9 0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m94.9 81.1c0 2.2-1.7 3.9-3.9 3.9-2.2 0-4-1.7-4-3.9 0-2.2 1.8-4 4-4 2.2 0 3.9 1.8 3.9 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.8ca42ae394c5c461e9d6e661bcfcf8d5.svg";
export { ForwardRef as ReactComponent };